import React from 'react';
import { Link } from 'react-router-dom';

const Gallery = () => {
    return (
        <>

            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top section_50">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2>Gallery</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/"> home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Gallery</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}



            {/* <!-- Gallery Area Start --> */}
            <section className="bleezy-gallery-area section_b_100">
                <div className="container">
                    <div className="mid-title text-center  mb-5 "><h2 className="heading-with-border">Gallery</h2></div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Bouncer.jpeg" alt="ignition" style={{ height: '273px' }} />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Bouncer.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Bouncer2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Bouncer2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Bouncer3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Bouncer3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Securityguard1.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Securityguard1.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Securityguard2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Securityguard2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Securityguard4.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Securityguard4.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Pantry1.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Pantry1.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Securityguard5.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Securityguard5.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Housekeeping2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Housekeeping2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Housekeeping.jpeg" alt="ignition" style={{ height: '238px' }} />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Housekeeping.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Escort1.jpg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Escort1.jpg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-4">
                            <div class="single-gallery-img">
                                <img src="assets/img/Gallery/Securityguard3.jpeg" alt="ignition" style={{ height: '238px' }} />
                                <div class="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Securityguard3.jpeg" target="_blank" class="more gallery2">
                                            <i class="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Pantry2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Pantry2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Pantry3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Pantry3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/img/Gallery/Housekeeping3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/img/Gallery/Housekeeping3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
            {/* <!-- Gallery Area End --> */}
        </>
    )
}

export default Gallery;
